import Inicio from '../views/Inicio.vue';
import Parlamentares from '../views/Parlamentares.vue';
import ParlamentaresEdit from '../views/Parlamentares.Edit.vue';
import Emendas from '../views/Emendas.vue';
import EmendasEdit from '../views/Emendas.Edit.vue';
import Decretos from '../views/Decretos.vue';
import DecretosEdit from '../views/Decretos.Edit.vue';
import Obras from '../views/Obras.vue';
import ObrasEdit from '../views/Obras.Edit.vue';
import Dotacoes from '../views/Dotacoes.vue';
import Admin from '../views/Admin.vue';
import Paineis from '../views/Paineis.vue';
//import Login from '../views/Login.vue';
import NotFound from '../views/404.vue';
import PainelEstadual from '../views/PainelEstadual.vue';
import PainelFederal from '../views/PainelFederal.vue';

export default [
	{
		path: '/',
		name: 'Inicio',
		component: Inicio
	},
	{
		path: '/parlamentares',
		name: 'Parlamentares',
		component: Parlamentares,
		meta: {
			functions: ['PARLAMENTAR_LISTAR']
		}
	},
	{
		path: '/parlamentares/:id',
		name: 'ParlamentaresEdit',
		component: ParlamentaresEdit,
		meta: {
			functions: ['PARLAMENTAR_LISTAR']
		}
	},
	{
		path: '/emendas',
		name: 'Emendas',
		component: Emendas,
		meta: {
			functions: ['EMENDA_LISTAR']
		}
	},
	{
		path: '/emendas/:id',
		name: 'EmendasEdit',
		component: EmendasEdit,
		meta: {
			functions: ['EMENDA_LISTAR']
		}
	},
	{
		path: '/decretos',
		name: 'Decretos',
		component: Decretos,
		meta: {
			functions: ['DECRETO_LISTAR']
		}
	},
	{
		path: '/decretos/:id',
		name: 'DecretosEdit',
		component: DecretosEdit,
		meta: {
			functions: ['DECRETO_LISTAR']
		}
	},
	{
		path: '/obras',
		name: 'Obras',
		component: Obras,
		meta: {
			functions: ['OBRAS_LISTAR']
		}
	},
	{
		path: '/obras/:id',
		name: 'ObrasEdit',
		component: ObrasEdit,
		meta: {
			functions: ['OBRAS_LISTAR']
		}
	},
	{
		path: '/dotacoes',
		name: 'Dotacoes',
		component: Dotacoes,
		meta: {
			functions: ['DOTACAO_CONSULTAR']
		}
	},
	{
		path: '/admin',
		name: 'Admin',
		component: Admin,
		meta: {
			functions: ['USUARIO_LISTAR']
		}
	},
	{
		path: '/paineis',
		name: 'Paineis',
		component: Paineis
	},
	{
		path: '/painelEstadual',
		name: 'PainelEstadual',
		component: PainelEstadual
	},
	{
		path: '/painelFederal',
		name: 'PainelFederal',
		component: PainelFederal
	},
	{
		path: '*',
		name: '404',
		component: NotFound
	}
];
